// includes/auth/apiEmailInbox.js
//
// API layer for the Email Inbox feature (spec §20) -- reuses apiFetch/
// buildQuery from apiEmailMarketing.js (the same plain-JSON convention
// every other Email Marketing endpoint already uses) rather than a second,
// parallel fetch helper.

import { apiFetch, buildQuery } from "./apiEmailMarketing";

// `filter` ("unread"/"read", sidebar nav) narrows the query server-side
// across the WHOLE Inbox -- never a client-side filter of one loaded page.
export const getEmailInboxPageAPI = ({ page = 1, limit = 25, filter } = {}, token) => {
  const query = buildQuery({ page, limit, filter });
  return apiFetch(`/email-inbox${query ? `?${query}` : ""}`, { token });
};

export const getEmailInboxUnreadCountAPI = (token) => apiFetch("/email-inbox/unread-count", { token });

export const getEmailInboxEmailAPI = (emailId, token) => apiFetch(`/email-inbox/${emailId}`, { token });

export const markEmailInboxReadAPI = (emailId, token) =>
  apiFetch(`/email-inbox/${emailId}/read`, { method: "PATCH", token });

export const markAllEmailInboxReadAPI = (token) =>
  apiFetch("/email-inbox/read-all", { method: "PATCH", token });
